import React from "react";
import { useState, useEffect } from "react";
import { Box } from "@mui/material";
import { ResponsiveBar } from "@nivo/bar";
import Header from "../../components/Header"; // si ya tienes este componente
import { getStock2TejidoStock } from "../../services/stockTejido.services";
import useMediaQuery from "@mui/material/useMediaQuery";

const ProduccionTejido = () => {
  const [dataProductos, setDataProductos] = useState([]);
  const [data, setData] = useState([]);
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const [totalProduccion, setTotalProduccion] = useState(0);

 useEffect(() => {
  const fetchStock = async () => {
    try {
      const stock = await getStock2TejidoStock();

      // Contar cuántos registros hay por empresa
      const conteoProductos = {};
      stock.forEach((item) => {
          const producto = item.producto_descripcion; // <-- Cambiar según cómo se llame en tu BD
          if (conteoProductos[producto]) {
            conteoProductos[producto] += 1;
          } else {
            conteoProductos[producto] = 1;
          }
      });

      const parsedProductos = Object.entries(conteoProductos).map(
          ([producto, total]) => ({
            id: `Producto ${producto}`,
            label: `Producto ${producto}`,
            value: total,
          })
        );

      // Transformar al formato que requiere Nivo Pie
      const parsedData = Object.entries(conteoProductos).map(([empresa, total]) => ({
        id: `Empresa ${empresa}`,
        label: `Empresa ${empresa}`,
        value: total, // cada 'value' es la cantidad de registros
        color: getColorByEmpresa(empresa),
      }));

      setDataProductos(parsedProductos);

      setData(parsedData);
      const total = parsedData.reduce((acc, item) => acc + item.value, 0);
        setTotalProduccion(total);
    } catch (error) {
      console.error("Error al obtener el stock de tejido:", error);
    }
  };

  fetchStock();
}, []);


  // Función para asignar colores por empresa
  const getColorByEmpresa = (empresa) => {
    switch (empresa) {
      case "Evoluaco": return "#52f5ff";
      case "Sideragro": return "#ec407a";
      case "Interno": return "#ffc548";
      default: return "hsl(0, 0%, 50%)";
    }
  };

  return (
    <Box m="20px">
      <Header title="Estadísticas" subtitle="Producción de rollos" />
      <Box
        display="flex"
        justifyContent="center"
        sx={{
          "& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
        }}
        >
      <Box height="55vh" width="100%">
        <Box display="flex" justifyContent="center" mb={2}>
            <Box sx={{ color: "#fff", fontSize: 20, fontWeight: "bold" }}>
                Total Producción: {totalProduccion} rollos
            </Box>
    </Box>
       <ResponsiveBar
  data={data}
  keys={["value"]}
  indexBy="label"
  margin={{ top: 50, right: 130, bottom: 100, left: 60 }}
  padding={0.3}
  valueScale={{ type: "linear" }}
  indexScale={{ type: "band", round: true }}
  colors={({ data }) => data.color}
  borderColor={{ from: "color", modifiers: [["darker", 1.6]] }}
  axisTop={null}
  axisRight={null}
  axisBottom={{
    tickSize: 5,
    tickPadding: 5,
    tickRotation: -45,
    legend: "Producto",
    legendPosition: "middle",
    legendOffset: 70,
  }}
  axisLeft={{
    tickSize: 5,
    tickPadding: 5,
    legend: "Cantidad",
    legendPosition: "middle",
    legendOffset: -50,
  }}
  labelSkipWidth={12}
  labelSkipHeight={12}
  labelTextColor={{ from: "color", modifiers: [["darker", 1.6]] }}
  tooltip={({ data }) => (
    <div
      style={{
        padding: "6px 12px",
        background: data.color,
        color: "#fff",
        borderRadius: "4px",
        fontSize: "16px",
      }}
    >
      <strong>{data.label}:</strong> {data.value} rollos
    </div>
  )}
  theme={{
    axis: {
      ticks: {
        text: {
          fill: "#ffffff",
          fontSize: 12,
        },
      },
      legend: {
        text: {
          fill: "#ffffff",
          fontSize: 14,
        },
      },
    },
    labels: {
      text: {
        fill: "#ffffff",
        fontSize: 14,
      },
    },
  }}
/>

        <Box display="flex" justifyContent="center" mt={4}>
          {data.map((item) => (
            <Box key={item.id} display="flex" alignItems="center" mx={2}>
              <Box
                sx={{
                  width: 12,
                  height: 12,
                  borderRadius: "50%",
                  backgroundColor: item.color,
                  mr: 1,
                }}
              />
              <Box sx={{ color: "#fff", fontSize: 14 }}>
                {item.label.replace("Empresa ", "")}
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
      </Box>
    </Box>
  );
};

export default ProduccionTejido;